import { ReactNode, useCallback } from "react";
import { NavigationButton } from "../NavigationButton";
import { useLocation, useNavigate } from "react-router-dom";

interface NavigationItem {
  content: ReactNode;
  path?: string;
  isCustomContent?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

interface Props {
  leftItems?: NavigationItem[];
  rightItems?: NavigationItem[];
}

export const Navigation = ({ leftItems, rightItems }: Props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const renderGroup = useCallback(
    (items: NavigationItem[]) =>
      items
        .filter((item) => item.content)
        .map((item, index) => (
          <NavigationButton
            key={item.path || index}
            content={item.content}
            active={item.path === location.pathname}
            disabled={!!item.disabled}
            onClick={() => {
              if (item.disabled) return;
              if (item.onClick) {
                item.onClick();
              } else if (item.path) {
                navigate(item.path);
              }
            }}
            isCustomContent={!!item.isCustomContent}
          />
        )),
    [location.pathname, navigate],
  );

  return (
    <div className="flex justify-between h-[30px]">
      <div className="flex gap-5 items-center">
        {renderGroup(leftItems || [])}
      </div>
      <div className="flex gap-5 items-center">
        {renderGroup(rightItems || [])}
      </div>
    </div>
  );
};
